import * as React from "react";
import useSWR from "swr";
import fetcher from "./fetcher";

const baseEndpoint = "/api/talentDashboard/getPaidV2/summary";

export default function useGetPaidSummary(influencerId) {
  const url = React.useMemo(() => {
    const params = new URLSearchParams();
    if (influencerId) {
      params.set("influencer_id", String(influencerId));
    }
    const qs = params.toString();
    return qs ? `${baseEndpoint}?${qs}` : baseEndpoint;
  }, [influencerId]);

  const { data, error, mutate } = useSWR(url, fetcher, {
    keepPreviousData: true,
  });

  return {
    summary: data ?? null,
    isLoading: !data && !error,
    error,
    refresh: mutate,
  };
}
